import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Error404Component } from '../../../common/components/error-404/error-404.component';
import { CanDeactivateGuard, Logged, OrganizationOwner } from './core/guard/auth.guard';
import { ChatDetailComponent } from './routes/chats/chat-detail/chat-detail.component';
import { ChatListComponent } from './routes/chats/chat-list/chat-list.component';
import { HomeComponent } from './routes/home/home.component';
import { LoginComponent } from './routes/login/login.component';
import { PasswordRecoveryComponent } from './routes/login/password-recovery/password-recovery.component';
import { ValidateInvitationComponent } from './routes/login/validate-invitation/validate-invitation.component';
import { LoginGuestComponent } from './routes/login-guest/login-guest.component';
import { OnboardingComponent } from './routes/onboarding/onboarding.component';
import { NotificationsConfigurationComponent } from './routes/profile/notifications-configuration/notifications-configuration.component';
import { OrganizationComponent } from './routes/profile/organization/organization.component';
import { OrganizationPermissionsComponent } from './routes/profile/organization-permissions/organization-permissions.component';
import { ProfileComponent } from './routes/profile/profile.component';
import { UserDataComponent } from './routes/profile/user-data/user-data.component';
import { RecordListComponent } from './routes/record-list/record-list.component';
import { RecordNotFoundComponent } from './routes/record-not-found/record-not-found.component';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login-guest', component: LoginGuestComponent },
  { path: 'onboarding', component: OnboardingComponent },
  { path: 'validate-email', component: OnboardingComponent },
  { path: 'validate-invitation', component: ValidateInvitationComponent },

  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'profile',
        component: ProfileComponent,
        children: [
          { path: 'user-data', component: UserDataComponent },
          { path: 'permissions', component: OrganizationPermissionsComponent },
          { path: 'organization', component: OrganizationComponent, canActivate: [OrganizationOwner] },
          { path: 'notifications-configuration', component: NotificationsConfigurationComponent, canDeactivate: [CanDeactivateGuard] },
        ],
      },
      { path: 'onboarding', component: OnboardingComponent },
      { path: 'password-recovery', component: PasswordRecoveryComponent },
      { path: '', redirectTo: '/record-list', pathMatch: 'full' },
      { path: 'record-list', component: RecordListComponent },
      { path: 'record-detail', loadChildren: () => import('./modules/record-detail-module/record-detail-module.module').then(m => m.RecordDetailModuleModule) },
      { path: 'record-not-found/:id', component: RecordNotFoundComponent },
      { path: 'messages', component: ChatListComponent },
      { path: 'messages/:id', component: ChatDetailComponent },
    ],
    canActivate: [Logged],
  },
  { path: '404', component: Error404Component },
  { path: '**', component: Error404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
